/**
 * One realtime listener per table instead of three.
 *
 * Every `.on('postgres_changes', ...)` a client registers becomes a
 * row in realtime.subscription, and Supabase's WAL decoder evaluates
 * that table's row-level security once per matching row for every
 * change that comes through the replication slot. Registering INSERT,
 * UPDATE and DELETE separately therefore made the database run the
 * same access check three times for every single write — multiplied
 * by every browser tab that happens to be open.
 *
 * `event: '*'` is one subscription row and one check, with the event
 * type arriving on the payload instead.
 *
 * On `deals` that matters most: it takes more writes than the rest of
 * the realtime publication put together.
 */
export function onAnyChange(handlers) {
  return (payload) => {
    const handler = handlers?.[payload?.eventType];
    // An event nobody registered for is not an error. Supabase can
    // send a truncate or a type it has newly learned about, and a
    // realtime handler that throws takes the whole channel down with
    // it — every table on it, silently, until the tab is reloaded.
    if (typeof handler === 'function') handler(payload);
  };
}
